// removed by extract-text-webpack-plugin
module.exports = {"Header":"Header__1j2Yj","TagLine":"TagLine__2Pbs4"};


//////////////////
// WEBPACK FOOTER
// ./components/Header/Header.css
// module id = gPbD
// module chunks = 0